import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MUrlService {
  readonly params$ = new BehaviorSubject<Params>({});

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe(this.params$);
  }

  params(): Params {
    return this.params$.value;
  }

  setParams(params: Params): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { ...params }
    });
  }
}
